// extracted by mini-css-extract-plugin
module.exports = {"slot":"QuickBookingSlot_slot__DWxOD","slot-skeleton":"QuickBookingSlot_slot-skeleton__MtOKG"};